import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  Filter,
  FunctionField,
  List,
  SearchInput,
  SelectInput,
  TextField,
  useRecordContext,
} from 'react-admin';
import ListPagination from '../../components/ListPagination';
import { formatCnpj } from '../../utils';

const StationsFilter = () => (
  <Filter>
    <SearchInput source="search" alwaysOn placeholder="Nome, CNPJ ou cidade" />
    <SelectInput
      source="status"
      label="Status"
      choices={[{ id: true, name: 'Ativo' }, { id: false, name: 'Inativo' }]}
      emptyText="Todos"
      alwaysOn
    />
  </Filter>
);

/**
 * Último abastecimento do posto.
 *
 * O backend devolve dois campos porque as fontes são duas: `lastFillinAt` é o
 * timestamp exato dos últimos dias (tabela fillin) e `lastFillinDate` é a data
 * do agregado D-1 (fillin_summary), que cobre o histórico. Quando só existe a
 * data, mostra só a data — não inventa hora.
 */
const LastFillinField: React.FC<{ label?: string; source?: string; sortable?: boolean }> = () => {
  const record = useRecordContext();
  if (!record) { return null; }

  if (record.lastFillinAt) {
    return <span>{dayjs(record.lastFillinAt).format('DD/MM/YYYY HH:mm')}</span>;
  }

  if (record.lastFillinDate) {
    return <span>{dayjs(record.lastFillinDate).format('DD/MM/YYYY')}</span>;
  }

  return <span>--</span>;
};

const ChainStationsTab: React.FC = () => {
  const chain = useRecordContext();
  if (!chain?.id) { return null; }

  return (
    <List
      title=" "
      resource="chain-stations"
      filter={{ chainId: chain.id }}
      filters={<StationsFilter />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      pagination={<ListPagination />}
      actions={false}
      exporter={false}
      empty={(
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Nenhum posto cadastrado nesta rede.</Typography>
        </Box>
      )}
      disableSyncWithLocation
    >
      <Datagrid
        bulkActionButtons={false}
        rowClick={(id) => `/stations/${id}/show`}
      >
        <TextField source="name" label="Posto" />
        <FunctionField source="cnpj" label="CNPJ" render={(station: any) => formatCnpj(station.cnpj)} />
        <BooleanField source="isActive" label="Ativo" />
        <DateField source="createdAt" label="Cadastrado em" />
        <LastFillinField label="Último abastecimento" source="lastFillinAt" />
      </Datagrid>
    </List>
  );
};

export default ChainStationsTab;
